import { render, staticRenderFns } from "./PracticeFeeAdd.vue?vue&type=template&id=8105d6ea&scoped=true&"
import script from "./PracticeFeeAdd.vue?vue&type=script&lang=js&"
export * from "./PracticeFeeAdd.vue?vue&type=script&lang=js&"
import style0 from "./PracticeFeeAdd.vue?vue&type=style&index=0&id=8105d6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8105d6ea",
  null
  
)

export default component.exports